module.exports = __webpack_public_path__ + "static/media/classPassLogo.d68a69b8.png";